import { jsx as _jsx } from "react/jsx-runtime";
import { boxStyle, normalizeStyle } from '../Box/Box';
const BOX_PROP_KEYS = new Set([
    'p', 'px', 'py', 'pt', 'pr', 'pb', 'pl',
    'm', 'mx', 'my', 'mt', 'mr', 'mb', 'ml',
    'ps', 'pe', 'ms', 'me', 'pbs', 'pbe', 'mbs', 'mbe',
    'rounded', 'shadow', 'border', 'bg', 'color',
]);
function splitBoxProps(props) {
    const boxProps = {};
    const rest = {};
    for (const k of Object.keys(props)) {
        (BOX_PROP_KEYS.has(k) ? boxProps : rest)[k] = props[k];
    }
    return { boxProps: boxProps, rest };
}
export function Stack({ as: Tag = 'div', gap, align, justify, wrap, children, className, style: extraStyle, ...rest }) {
    const { boxProps, rest: domProps } = splitBoxProps(rest);
    // Emit gap as rowGap/columnGap longhand to keep style serialization
    // deterministic across SSR + hydration. See Box.tsx normalizeStyle for why.
    const gapValue = gap != null ? `var(--space-${gap})` : undefined;
    const style = {
        display: 'flex',
        flexDirection: 'column',
        ...(gapValue != null ? { rowGap: gapValue, columnGap: gapValue } : {}),
        ...(align ? { alignItems: align } : {}),
        ...(justify ? { justifyContent: justify } : {}),
        ...(wrap ? { flexWrap: 'wrap' } : {}),
        minWidth: 0,
        ...boxStyle(boxProps),
        ...normalizeStyle(extraStyle),
    };
    return (_jsx(Tag, { className: className, style: style, ...domProps, children: children }));
}
//# sourceMappingURL=Stack.js.map